import { render, staticRenderFns } from "./walletBar.vue?vue&type=template&id=d4e8f7ce&scoped=true&"
import script from "./walletBar.vue?vue&type=script&lang=ts&"
export * from "./walletBar.vue?vue&type=script&lang=ts&"
import style0 from "./walletBar.vue?vue&type=style&index=0&id=d4e8f7ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e8f7ce",
  null
  
)

export default component.exports